export default function useHeadData(metadata) {
  useHead({
    title: metadata.title
      ? `${metadata.title}`
      : 'Supraphon',
    meta: [
      {
        name: 'description',
        content:
          metadata.description ||
          'Hudební vydavatelství SUPRAPHON je historicky nejvýznamnější českou gramofonovou firmou. Značka SUPRAPHON byla zaregistrována již v roce 1932. Archiv SUPRAPHONu je bezkonkurenčně nejbohatším hudebním archivem v České republice.',
      },
			{
        name: 'author',
        content:
          metadata.author ||
          'Brainz Disruptive',
      },
			{
        name: 'keywords',
        content:
          metadata.keywords ||
          '',
      },
			{
        name: 'copyright',
        content:
          metadata.copyright ||
          '',
      },
      // facebook open graph
      {
        hid: 'og:title',
        property: 'og:title',
        content: metadata.og.title
          ? `${metadata.og.title}`
          : 'Supraphon',
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content:
          metadata.og.description ||
          'Hudební vydavatelství SUPRAPHON je historicky nejvýznamnější českou gramofonovou firmou. Značka SUPRAPHON byla zaregistrována již v roce 1932. Archiv SUPRAPHONu je bezkonkurenčně nejbohatším hudebním archivem v České republice.',
      },
			{
        hid: 'og:type',
        property: 'og:type',
        content:
          metadata.og.type ||
          'website',
      },
			{
        hid: 'og:site_name',
        property: 'og:site_name',
        content:
          metadata.og.site_name ||
          'supraphon.com',
      },
			{
        hid: 'og:image',
        property: 'og:image',
        content: metadata.og.image
      },
			{
        hid: 'og:url',
        property: 'og:url',
        content: metadata.url
      },
    ],
  })
}
